export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/touchpoint-start.11985cce-0876fe.png";